// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing234({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle10
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        videoPath={`${process.env.REACT_APP_CDN_BASE}/images/218/01.mp4`}
        videoBottmIMG={`${process.env.REACT_APP_CDN_BASE}/images/218/02.webp`}
        qTitleColor="#660002"
        qOptionColor="blue"
        formFieldColor="white"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/red/applyButton2.png`}
        companyName="본원"
        privacyCompanyName="세계로탑치과의원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      />
    </>
  );
}
export default Randing234;
